class bhs_buttons {
  static get selectors() {
    return {
      //offsetAnimation: '800'
    };
  }
  static init() {
    $(".bhs-nav-sectionBtn").click(function() {
      $(".bhs-nav-sectionBtn").removeClass("active");

      $(this).addClass("active");
      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 100
        },
        500
      );

      $(".hamburger--collapse").toggleClass("is-active");

      $(".bhs-nav-sidedoor").toggleClass("active");

      return false;
    });

    $(".bhs-footer-brandsBtn").click(function() {
      $(".bhs-footer-brandsBtn").removeClass("active");

      $(this).addClass("active");
      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 100
        },
        500
      );

      if ($(".bhs-footer-brandsBtn.company").hasClass("active")) {
        $(".bhs-nav-sectionBtn").removeClass("active");
        $(".bhs-nav-sectionBtn.company").addClass("active");
      }

      if ($(".bhs-footer-brandsBtn.contact").hasClass("active")) {
        $(".bhs-nav-sectionBtn").removeClass("active");
        $(".bhs-nav-sectionBtn.contact").addClass("active");
      }

      if ($(".bhs-footer-brandsBtn.services").hasClass("active")) {
        $(".bhs-nav-sectionBtn").removeClass("active");
        $(".bhs-nav-sectionBtn.services").addClass("active");
      }

      if ($(".bhs-footer-brandsBtn.team").hasClass("active")) {
        $(".bhs-nav-sectionBtn").removeClass("active");
        $(".bhs-nav-sectionBtn.team").addClass("active");
      }

      return false;
    });

    $(".button").append(
      "<span class='top-left'></span><span class='top-right'></span><span class='bottom-left'></span><span class='bottom-right'></span>"
    );
  }
}
module.exports = bhs_buttons;
